$(document).ready(function () {
  $('#styled-search-form input').focus(function () {
    $('#styled-search-form').addClass('focused');
  });
  $('#styled-search-form input').focusout(function () {
    $('#styled-search-form').removeClass('focused');
  });

  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      $('#search-input').val('');
    }
  });

  $('#search-input').on('input', function () {
    if ($(this).val() === '') {
      let resultProductList = $('.product-dropdown-results');
      resultProductList.html(null);
      resultProductList.removeClass('show');
    }
  });
});
